import React from 'react';

import useTranslate from './useTranslate';

type TranslateProps = {
  locale?: string;
  dealerLang?: string;
  toTranslate: Record<string, string>;
};

const Translate: React.FC<TranslateProps> = ({ locale, dealerLang, toTranslate, ...rest }) => {
  const { translate } = useTranslate({ dealerLang, locale });
  const translation = translate(toTranslate);

  return (
    <span {...rest}>{translation}</span>
  );
};

export default Translate;
